module.exports = __webpack_public_path__ + "img/measurement_info_back_chest_left.e6fe8f80.jpg";